import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dropdown, Navbar, NavbarContent, NavbarItem, DropdownTrigger, DropdownMenu, DropdownItem } from '@nextui-org/react';
import { ArrowDown, Loader2, ArrowUp } from 'lucide-react';
import { API_URL } from '../utils/constants';
import auth from '../Auth';

// Define a global variable for caching environments
let cachedEnvironments = null;

const NavbarComponent = () => {
  const [userData, setUserData] = useState(auth.userData);
  const [environments, setEnvironments] = useState([]);
  const [loadedEnvs, setLoadedEnvs] = useState(false);
  const [isDropdownEnvsOpen, setIsDropdownEnvsOpen] = useState(false);

  useEffect(() => {
    const fetchEnvironments = async () => {
      if (cachedEnvironments) {
        setEnvironments(cachedEnvironments);
        setLoadedEnvs(true);
      } else {
        const token = auth.syncGetIdToken();
        fetch(`${API_URL}/envs`, {
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
          }
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('Fetched environments:', data);
            cachedEnvironments = data; // Cache the fetched environments
            setEnvironments(data);
            setLoadedEnvs(true);
          })
          .catch((error) => console.error('Error fetching environments:', error));
      }
    };

    if (isDropdownEnvsOpen) {
      fetchEnvironments();
    }
  }, [isDropdownEnvsOpen]);

  const handleEnvironmentSelection = async (environmentId) => {
    await axios.post(
      `${API_URL}/user_attrs`,
      { env_name: environmentId },
      {
        headers: {
          Authorization: `Bearer ${auth.syncGetIdToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );

    
    // Clear recent prompts from localStorage
    localStorage.removeItem('recentPrompts');
    
    auth.syncRefreshToken();
  };

  return (
    <Navbar maxWidth='2xl'>
      <NavbarContent className='flex justify-end items-center w-full'>
        <NavbarItem className='ml-auto'>
          <span>{userData.org_name}</span>
        </NavbarItem>
        <NavbarItem>
          {userData.env_name !== '' && (
            <Dropdown isOpen={isDropdownEnvsOpen} onOpenChange={setIsDropdownEnvsOpen}>
              <DropdownTrigger>
                <div className='flex items-center space-x-2 cursor-pointer'>
                  <span>{userData.env_name}</span>
                  {!isDropdownEnvsOpen ? <ArrowDown /> : <ArrowUp />}
                </div>
              </DropdownTrigger>
              <DropdownMenu>
                {loadedEnvs ? (
                  environments.map((env) => (
                    <DropdownItem key={env.env_name} onClick={() => handleEnvironmentSelection(env.env_name)}>
                      {env.env_name}
                    </DropdownItem>
                  ))
                ) : (
                  <DropdownItem>
                    <Loader2 className='animate-spin' />
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          )}
        </NavbarItem>
      </NavbarContent>
    </Navbar>
  );
};

export default NavbarComponent;